import { useEffect, useState , useRef } from "react";
import { Card, Accordion } from 'react-bootstrap';
import Select from "react-dropdown-select";
import CustomDropdown from "../CustomDropdown";
import CustomControl from "../CustomControl";
import CustomDropdownWithSearch from "../CustomDropdownWithSearch";
import CustomControlMulti from "../CustomControlMulti";
import CustomDropdownMulti from "../CustomDropdownMulti";
import OverlayContainer from "../OverlayContainer";
import { DebounceInput } from "react-debounce-input";
import {
  capitalizeWordsText,
} from "../../Functions/TextTransform";

export default function Step9BcomponentPleated({
 step8,
 depSet,
 accordionActiveKey,
 ContextAwareToggle,
 t,
 requiredStep,
 stepSelectedLabel,
 tracksList,
 rodsList3,
 step8B,
 setStep8B1,
 setStep8B2,
 setStep8B3,
 setSelectedSheer,
 setStep8B,
 extendedTitle,
 setExtendedTitle,
 setDeps,
 setCart,
 selectChanged,
 inputs,
 rodsColorList3,
 rodsLoad2,
 widthCart,
 step6BHead,
 step6B,
 modalHandleShow,
 setHardwareSheerWarningTemp,
 step6,
 setStep6BHead,
 trackType8B,
 step8B3,
 modelAccessories,
 pageLanguage,
 GetPrice,
 isTabletOrMobile,
 step8B5,
 setStep8B5,
 motorErr1,
 setMotorErr1,
 setSelectedMotorPositionB,
 selectedMotorPositionB,
 setSelectedRemoteName,
 setSelectedMotorChannelsB,
 selectedMotorChannelsB,
 selectedSheer,
 selectedRemoteName,
 remoteNames,
 MotorPosition,
 motorChannels,
 sheersSelect,
 sheersSelect2,
 sheersSelect3,
 pageLoad,
 rodsLoad,
 setRemoteNameB,
 selectUncheck,
 setShowRemoteName,
 setCartLoading,
 remoteNameB,
 showRemoteName,
 Capitalize,
 NextStep,
 step31,
 step3,
 step9ADrapery,
 selectedDrapery,
 setStep8BRilType,
 step8BRilType,
 setRemove9A,
 step5,
 windowWidthPanelType
}) {
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDisabledRod, setIsDisabledRod] = useState(false);
  const [sheerDraperyOptions, setSheerDraperyOptions] = useState(sheersSelect[pageLanguage]);
  const motorChannelsUserOpenRefB = useRef(false);


  useEffect(() => {
    let newIsDisabled;
    let newIsDisabledRod;
    if (step31 === "false" && parseInt(windowWidthPanelType) < 160) {
      newIsDisabled = false;
    } else if (step6BHead === "Track") {
      newIsDisabled = false;
    } else if (step6BHead === "Rod" && parseInt(windowWidthPanelType) > 160) {
      newIsDisabled = true;
    } else if (step3 === "false" && parseInt(windowWidthPanelType) <= 160) {
      newIsDisabled = false;
    } else if (step3 === "true" && parseInt(windowWidthPanelType) <= 160 && step31 === "true") {
      newIsDisabled = true;
    }

    if (step6BHead === "Rod" && parseInt(windowWidthPanelType) > 160) {
      newIsDisabledRod = false;
    } else if (step6BHead === "Track" && parseInt(windowWidthPanelType) > 160 ) {
      newIsDisabledRod = true;
    } else if (step6BHead === "Track" && parseInt(windowWidthPanelType) <= 160 && step31 === 'true' && step3 === "true"  ) {
      newIsDisabledRod = true;
    } else if (step6BHead === "Track" && parseInt(windowWidthPanelType) <= 160 && step31 === "Track" && step3 === "true"  ) {
      newIsDisabledRod = true;
    } else if (step6BHead === "Rod" && parseInt(windowWidthPanelType) <= 160 && step31 === "false" && step3 === "true" && step9ADrapery === "Track"  ) {
      newIsDisabledRod = true;
    } else if (step6BHead === "Rod" && parseInt(windowWidthPanelType) <= 160 && step31 === "" && step3 === "false" && step9ADrapery === "Track"  ) {
      newIsDisabledRod = true;
    } else  if (selectedDrapery && selectedDrapery[0] && (selectedDrapery[0].num === "3" || selectedDrapery[0].num === "4" || selectedDrapery[0].num === "5")  && step31 === "" && parseInt(windowWidthPanelType) <= 160 && step3 === "false" ) {
      newIsDisabledRod = true;
    } else  {
      newIsDisabledRod = false;
    }

      if (selectedDrapery && selectedDrapery[0] && (selectedDrapery[0].num === "3" || selectedDrapery[0].num === "4" || selectedDrapery[0].num === "5")  && step31 === "false" && parseInt(windowWidthPanelType) <= 160 ) {
      setSheerDraperyOptions(sheersSelect2[pageLanguage]);
    } else if (selectedDrapery && selectedDrapery[0] && (selectedDrapery[0].num === "3" || selectedDrapery[0].num === "4" || selectedDrapery[0].num === "5")  && step31 === "" && parseInt(windowWidthPanelType) <= 160 ) {
      setSheerDraperyOptions(sheersSelect2[pageLanguage]);
    } else if (parseInt(windowWidthPanelType) <= 160 && step31 === "" && step3 === "false" && step9ADrapery === "Track") {
      setSheerDraperyOptions(sheersSelect2[pageLanguage]);
    }  else if (parseInt(windowWidthPanelType) <= 160 && step31 !== "true" && step3 !== "true") {
      setSheerDraperyOptions(sheersSelect3[pageLanguage]);
    }  else if (parseInt(windowWidthPanelType) <= 160 && step31 === "false" && step3 === "true" && step9ADrapery === "Track") {
      setSheerDraperyOptions(sheersSelect2[pageLanguage]);
    } else if (parseInt(windowWidthPanelType) <= 160 && step31 === "true" && step3 === "true" && step6BHead === "Rod") {
      setSheerDraperyOptions(sheersSelect[pageLanguage]);
    }  else if (parseInt(windowWidthPanelType) <= 160 && step31 === "false" && step3 === "true") {
      setSheerDraperyOptions(sheersSelect3[pageLanguage]);
    } else if (step6BHead === "Rod") {
      setSheerDraperyOptions(sheersSelect[pageLanguage]);
    } else if ( parseInt(windowWidthPanelType) <= 160 && step31 === "true" && step3 === "true" && step6BHead === "Track") {
      setSheerDraperyOptions(sheersSelect2[pageLanguage]);
    } else {
      setSheerDraperyOptions(sheersSelect2[pageLanguage]);
    }

    setIsDisabled(newIsDisabled);
    setIsDisabledRod(newIsDisabledRod);

    if (step9ADrapery === "Track" && step8B === "Rod") {
      setStep8B("");
      setStep8B3("");
      setStep8B2("");
      setRemove9A(true);
      setDeps("8B", "");
      let tempExtended = extendedTitle;
       tempExtended["8B"] = [t("")];
       setExtendedTitle(tempExtended);
    }
  }, [step31, windowWidthPanelType, step6BHead, step3 , step9ADrapery , selectedDrapery ]);

  
  return (
   <Card
   className={step8 === "I Want To Customize Hardware Per Curtain" ? "" : "noDisplay"}
 >
   <Card.Header
     className={
       [...depSet].findIndex((el) => el.startsWith("8")) === -1 &&
       !accordionActiveKey.startsWith("8")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="8B"
       stepNum={ step5 === "Full" && step3 === "false" ? t("8B") : t("9B")}
       stepTitle={t("grommet_step8B")}
       stepRef="8B"
       type="1"
       required={requiredStep["8B"]}
       stepSelected={
         stepSelectedLabel["8B"] === undefined ? "" : stepSelectedLabel["8B"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="8B">
     <Card.Body>
       <div
         className={
           "card_body2 card_body_radio card_body_radio_new card_body_hardware" +
           (tracksList.length > 0 && rodsList3.length > 0 ? " " : "")
         }
       >
         <div className="boxHardware radio_style">
           <input
             className="radio"
             type="radio"
             text={t("None")}
             value="1"
             name="step8B"
             ref-num="8B"
             id="8B1"
             checked={step8B === "None"}
             onChange={(e) => {
               setStep8B1("");
               setStep8BRilType("");
               setStep8B2("");
               setStep8B3("");
               setSelectedSheer([]);
               if(step9ADrapery === "") {
                setDeps("8B" , "849,850,852,853,854,855,856,857,86");
               }else{
                 setDeps("86" , "849,850,852,853,854,855,856,857,8B");
               }
               setStep8B("None");
               let tempExtended = extendedTitle;
               tempExtended["8B"] = [t("None")];
               setExtendedTitle(tempExtended);
             
               setCart(
                 "SheerHardware",
                 "None",
                 "RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hardwareSheer"
               );
               selectChanged(e);
             }}
             ref={(ref) => (inputs.current["8B1"] = ref)}
           />
           <label htmlFor="8B1">{t("None")}</label>
         </div>
         <div className={rodsList3.length > 0 ? "boxHardware radio_style" : "noDisplay"}>
           <input
             className="radio"
             type="radio"
             text={t("sheer_Rod")}
             value="3"
             name="step8B"
             ref-num="8B"
             id="8B3"
             checked={step8B === "Rod"}
             disabled={isDisabledRod}
             onChange={(e) => {
             
               if (
                 parseInt(windowWidthPanelType) > 160 &&
                 step6BHead === "Track" &&
                 step6B !== ""
               ) {
                 modalHandleShow("hardwareSheerWarning");
                 setHardwareSheerWarningTemp({
                   stepValue: "Rod",
                   id: "sheer_Rod",
                   cartValue: "Rod",
                   event: e,
                 });
               } else {
                 setStep8B1("");
                 setStep8BRilType("");
                 setStep8B2("");
                 setStep8B3("");
                
                 if(step9ADrapery === "") {
                  setDeps("8C,849,85" , ",850,852,853,854,855,856,857,86,8A,8B");
                 }else{
                  setDeps("849" , "8B,86,850,852,853,854,855,856,857");
                 }
                 setTimeout(() => {
                   setStep8B("Rod");
                   if (step6 !== "Customize Style Per Curtain") {
                     setStep6BHead("Rod");
                   }
                 }, 300);
                 let tempExtended = extendedTitle;
                 tempExtended["8B"] = [t("sheer_Rod")];
                 setExtendedTitle(tempExtended);
                
                 setCart(
                   "SheerHardware",
                   "Rod",
                   "RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hardwareSheer"
                 );
                 selectChanged(e);
                 
               }
             }}
             ref={(ref) => (inputs.current["8B3"] = ref)}
           />
           <label htmlFor="8B3">
             {t("sheer_Rod")}
             <br />
             {
              isDisabledRod && (
                 <OverlayContainer
                   classNames="extension_unavailable"
                   placement="bottom"
                   children={
                     <div className="extension_unavailable_title text_underline">
                       {t("Why is this unavailable?")}
                     </div>
                   }
                   component={
                     <div className="extension_unavailable_container">
                       <div className="extension_unavailable_text">
                         {t("track_sheer_hardware_text")}
                       </div>
                     </div>
                   }
                 />
               )}
           </label>
         </div>
         <div className={tracksList.length > 0 ? "boxHardware radio_style" : "noDisplay"}>
           <input
             className="radio"
             type="radio"
             text={t("sheer_Track")}
             value="2"
             name="step8B"
             ref-num="8B"
             id="8B2"
             checked={step8B === "Track"}
             disabled={isDisabled}
             onChange={(e) => {
         
               if (parseInt(windowWidthPanelType) > 160 && step6BHead === "Rod" && step6B !== "") {
                 modalHandleShow("hardwareSheerWarning");
                 setHardwareSheerWarningTemp({
                   stepValue: "Track",
                   id: "sheer_Track",
                   cartValue: "Track",
                   event: e,
                 });
               } else {
                 setStep8B1("");
                 setStep8BRilType("");
                 setStep8B2("");
                 setStep8B3("");
                 setDeps("849" , "8B,86,850,852,853,854,855,856,857");
                 setTimeout(() => {
                   setStep8B("Track");
                   if (step6 !== "Customize Style Per Curtain") {
                     setStep6BHead("Track");
                   }
                 }, 300);
                 let tempExtended = extendedTitle;
                 tempExtended["8B"] = [t("sheer_Track")];
                 setExtendedTitle(tempExtended);
                 setCart(
                   "SheerHardware",
                   "Track",
                   "RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hardwareSheer"
                 );
                 selectChanged(e);
         
               }
             }}
             ref={(ref) => (inputs.current["8B2"] = ref)}
           />
           <label htmlFor="8B2">
             {t("sheer_Track")}
             <br />
             {isDisabled && (
                 <OverlayContainer
                   classNames="extension_unavailable"
                   placement="bottom"
                   children={
                     <div className="extension_unavailable_title text_underline">
                       {t("Why is this unavailable?")}
                     </div>
                   }
                   component={
                     <div className="extension_unavailable_container">
                       <div className="extension_unavailable_text">
                         {t("rod_sheer_hardware_text")}
                       </div>
                     </div>
                   }
                 />
               )}
           </label>
         </div>
         

         {/* step 10 Questions */}
         <div
           className={
             step8B !== "None" && step8B !== ""
               ? "card_body card_body_radio card_body_Rod"
               : "noDisplay"
           }
         >
            <div className="box100">
            <p className="step_selection_title">

            {step8B === "Rod" ? t("Rod Collection") : t("Track Collection")}
            </p>
           </div>
           {step8B === "Rod" ? rodsList3 : tracksList}
         </div>
         <div
           className={
             step8B !== "None" && step8B !== "" && step8BRilType !== "" && !trackType8B
               ? "card_body card_body_radio card_body_Rod_color bracket_color"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title">
               {step8B === "Rod"
                 ? t("step8_rod_finish_title")
                 : t("step8_rod_finish_title_track")}
             </p>
           </div>
           {rodsColorList3}
         </div>
         <div
           className={
             step8B !== "None" && step8B !== "" && step8BRilType !== "" && trackType8B === 2
               ? "card_body card_body_radio card_body_Rod_color bracket_color"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title">
               {step8B === "Rod"
                 ? t("step8_rod_finish_title")
                 : t("step8_rod_finish_title_track")}
             </p>
           </div>
           {rodsColorList3}
         </div>

         <div
           className={
             step8B !== "None" && step8B !== "" && step8BRilType !== "" && !trackType8B
               ? "card_body card_body_radio card_body_baton"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title">
               {t("Baton Option")}
             </p>
           </div>
           <div className="box33 radio_style baton_style">
             <input
               className="radio"
               type="radio"
               text={t("None")}
               value="1"
               name="step8B3"
               ref-num="8B"
               id="8B31"
               checked={step8B3 === "None"}
               onChange={(e) => {
                 setStep8B3("None");
                 if(step8B === "Track"){
                  setDeps("", "8B3,853", 1);
                 }else{
                  setDeps("", "8B3,852", 1);
                 }
                
                 setCart("BatonOptionB", "None");
                 selectChanged(e);
                 let tempExtended = extendedTitle;
                 tempExtended["8B"][3] = (
                   <li key="3" className="step_title_extended_list_item">
                     <span className="step_title_extended_list_item_title">
                       {t("Baton")}
                     </span>
                     <span className="step_title_extended_list_item_text">
                       {t("None")}
                     </span>
                   </li>
                 );
                 setExtendedTitle(tempExtended);
               }}
               ref={(ref) => (inputs.current["8B31"] = ref)}
             />
             <label htmlFor="8B31">{t("None")}</label>
           </div>
           <div className="box33 radio_style baton_style">
             <input
               className="radio"
               type="radio"
               text={t("Baton 30cm")}
               value="2"
               name="step8B3"
               ref-num="8B"
               id="8B32"
               checked={step8B3 === "Baton 30cm"}
               onChange={(e) => {
                 setStep8B3("Baton 30cm");
                 if(step8B === "Track"){
                  setDeps("", "8B3,853", 1);
                 }else{
                  setDeps("", "8B3,852", 1);
                 }
                 setCart("BatonOptionB", "Baton 30cm");
                 selectChanged(e);
                 let tempExtended = extendedTitle;
                 tempExtended["8B"][3] = (
                   <li key="3" className="step_title_extended_list_item">
                     <span className="step_title_extended_list_item_title">
                       {t("Baton")}
                     </span>
                     <span className="step_title_extended_list_item_text">
                       {t("Baton 30cm")}
                     </span>
                   </li>
                 );
                 setExtendedTitle(tempExtended);
               }}
               ref={(ref) => (inputs.current["8B32"] = ref)}
             />
             <label htmlFor="8B32">
               {t("Baton 30cm")}
               <br />
               <p className="surcharge_price">
                 {Object.keys(modelAccessories).length !== 0
                   ? t("Add ")
                   : t("Surcharge Applies")}
                 {modelAccessories["27"]
                   ? modelAccessories["27"]["58"]
                     ? GetPrice(
                         modelAccessories["27"]["58"]["Price"],
                         pageLanguage,
                         t("TOMANS"),
                         isTabletOrMobile
                       )
                     : null
                   : null}
               </p>
             </label>
           </div>
           <div className="box33 radio_style baton_style">
             <input
               className="radio"
               type="radio"
               text={t("Baton 45cm")}
               value="3"
               name="step8B3"
               ref-num="8B"
               id="8B33"
               checked={step8B3 === "Baton 45cm"}
               onChange={(e) => {
                 setStep8B3("Baton 45cm");
                 if(step8B === "Track"){
                  setDeps("", "8B3,853", 1);
                 }else{
                  setDeps("", "8B3,852", 1);
                 }
                 setCart("BatonOptionB", "Baton 45cm");
                 selectChanged(e);
                 let tempExtended = extendedTitle;
                 tempExtended["8B"][3] = (
                   <li key="3" className="step_title_extended_list_item">
                     <span className="step_title_extended_list_item_title">
                       {t("Baton")}
                     </span>
                     <span className="step_title_extended_list_item_text">
                       {t("Baton 45cm")}
                     </span>
                   </li>
                 );
                 setExtendedTitle(tempExtended);
               }}
               ref={(ref) => (inputs.current["8B33"] = ref)}
             />
             <label htmlFor="8B33">
               {t("Baton 45cm")}
               <br />
               <p className="surcharge_price">
                 {Object.keys(modelAccessories).length !== 0
                   ? t("Add ")
                   : t("Surcharge Applies")}
                 {modelAccessories["27"]
                   ? modelAccessories["27"]["59"]
                     ? GetPrice(
                         modelAccessories["27"]["59"]["Price"],
                         pageLanguage,
                         t("TOMANS"),
                         isTabletOrMobile
                       )
                     : null
                   : null}
               </p>
             </label>
           </div>
           
         </div>
         <div
           className={
             step8B !== "None" && step8B !== "" && step8BRilType !== "" && trackType8B === 2
               ? "card_body card_body_radio card_body_baton"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title">{t("Control Position")}</p>
           </div>
           <div className="box33 radio_style">
             <div className="width_max">
               <img
                 src={require("../../Images/drapery/grommet/cp_hardware_left.svg").default}
                 className="img-fluid"
                 alt=""
               />
               <input
                 className="radio"
                 type="radio"
                 text={t("Left")}
                 value="5"
                 name="step8B3"
                 ref-num="8B"
                 id="8B35"
                 checked={step8B3 === "Left"}
                 onChange={(e) => {
                   setStep8B3("Left");
                   setDeps("", "8B3,854", 1);
                   setCart("ControlPositionB", "Left Control");
                   selectChanged(e);
                   let tempExtended = extendedTitle;
                   tempExtended["8B"][3] = (
                     <li key="3" className="step_title_extended_list_item">
                       <span className="step_title_extended_list_item_title">
                         {t("Control Position")}
                       </span>
                       <span className="step_title_extended_list_item_text">
                         {t("Left")}
                       </span>
                     </li>
                   );
                   setExtendedTitle(tempExtended);
                 }}
                 ref={(ref) => (inputs.current["8B35"] = ref)}
               />
               <label htmlFor="8B35">{t("Left")}</label>
             </div>
           </div>
           <div className="box33 radio_style">
             <div className="width_max">
               <img
                 src={require("../../Images/drapery/grommet/cp_hardware_right.svg").default}
                 className="img-fluid"
                 alt=""
               />
               <input
                 className="radio"
                 type="radio"
                 text={t("Right")}
                 value="6"
                 name="step8B3"
                 ref-num="8B"
                 id="8B36"
                 checked={step8B3 === "Right"}
                 onChange={(e) => {
                   setStep8B3("Right");
                   setDeps("", "8B3,854", 1);
                   setCart("ControlPositionB", "Right Control");
                   selectChanged(e);
                   let tempExtended = extendedTitle;
                   tempExtended["8B"][3] = (
                     <li key="3" className="step_title_extended_list_item">
                       <span className="step_title_extended_list_item_title">
                         {t("Control Position")}
                       </span>
                       <span className="step_title_extended_list_item_text">
                         {t("Right")}
                       </span>
                     </li>
                   );
                   setExtendedTitle(tempExtended);
                 }}
                 ref={(ref) => (inputs.current["8B36"] = ref)}
               />
               <label htmlFor="8B36">{t("Right")}</label>
             </div>
           </div>
         </div>

         <div className={step8BRilType === '2208' ? "tracks_motorized_section" : "noDisplay"}>
           <div
             className={
               motorErr1
                 ? "secondary_options secondary_options_err"
                 : "secondary_options"
             }
           >
             <div className="card-body-display-flex">
               <div className="width_max checkbox_style">
                 <input
                   type="checkbox"
                   text={t("Motorized")}
                   value="1"
                   name="step8B5"
                   ref-num="8B5"
                   checked={step8B5 === "true"}
                   onChange={(e) => {
                     if (e.target.checked) {
                       selectChanged(e);
                       setStep8B5("true");
                       setMotorErr1(false);
                       setSelectedMotorPositionB([]);
                       setDeps("855,856,857", "86,8B");
                       setSelectedRemoteName([]);
                       setSelectedMotorChannelsB([
                         motorChannels[pageLanguage].find((opt) => opt.value === "0"),
                       ]);
                       setRemoteNameB("");
                       setCart("hasPowerB", true, "", "MotorChannelsB", [
                         selectedMotorChannelsB.map((obj) => obj.value),
                       ]);
                     } else {
                       selectUncheck(e);
                       setStep8B5("");
                       setDeps("855,856,857", "86,8B");
                       setCart(
                         "",
                         "",
                         "hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB"
                       );
                     }
                   }}
                   id="8B51"
                   ref={(ref) => (inputs.current["8B51"] = ref)}
                 />
                 <label htmlFor="8B51" className="checkbox_label">
                   <img
                     className="checkbox_label_img checkmark1 img-fluid"
                     src={require("../../Images/public/checkmark1_checkbox.png")}
                     alt=""
                   />
                 </label>
                 <span className="checkbox_text">{t("Motor_title")}</span>
               </div>
             </div>
           </div>
           {motorErr1 && <div className="input_not_valid">{t("motorErr1")}</div>}
           <div
             className={
               trackType8B === 1 && step8B5 === "true"
                 ? "motorized_options"
                 : "noDisplay"
             }
           >
             <div className="motorized_option_left">
               <p>{t("Motor Position")}</p>
               &nbsp;
               <span onClick={() => modalHandleShow("learnMore2")}>
                 {t("(Learn More)")}
               </span>
             </div>
             <div className="motorized_option_right">
               <div className="select_container">
                 <Select
                   className="select"
                   placeholder={t("Please Select")}
                   portal={document.body}
                   dropdownPosition="bottom"
                   dropdownHandle={false}
                   dropdownGap={0}
                   values={selectedMotorPositionB}
                   onDropdownOpen={() => {
                     let temp1 = window.scrollY;
                     window.scrollTo(window.scrollX, window.scrollY + 1);
                     setTimeout(() => {
                       let temp2 = window.scrollY;
                       if (temp2 === temp1)
                         window.scrollTo(window.scrollX, window.scrollY - 1);
                     }, 100);
                   }}
                   dropdownRenderer={({ props, state, methods }) => (
                     <CustomDropdown props={props} state={state} methods={methods} />
                   )}
                   contentRenderer={({ props, state, methods }) => (
                     <CustomControl props={props} state={state} methods={methods} />
                   )}
                   onChange={(selected) => {
                     if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                       setSelectedMotorPositionB(selected);
                       setDeps("", "8B,855", 2);
                       setCart("MotorPositionB", selected[0].value);
                       let tempExtended = extendedTitle;
                       tempExtended["8B"][2] = (
                         <li key="2" className="step_title_extended_list_item">
                           <span className="step_title_extended_list_item_title">
                             {t("Motor Position")}
                           </span>
                           <span className="step_title_extended_list_item_text">
                             {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                           </span>
                         </li>
                       );
                     }
                   }}
                   options={MotorPosition[pageLanguage]}
                 />
               </div>
             </div>
             <div className="motorized_option_left">
               <p>{t("Remote Name")}</p>
               &nbsp;
               <span onClick={() => modalHandleShow("learnMore3")}>
                 {t("(Learn More)")}
               </span>
             </div>
             <div className="motorized_option_right">
               {!!(remoteNames.length > 1) && (
                 <div className="select_container">
                   <Select
                     className="select"
                     placeholder={t("Please Select")}
                     portal={document.body}
                     dropdownPosition="bottom"
                     dropdownHandle={false}
                     dropdownGap={0}
                     values={selectedRemoteName}
                     onDropdownOpen={() => {
                       let temp1 = window.scrollY;
                       window.scrollTo(window.scrollX, window.scrollY + 1);
                       setTimeout(() => {
                         let temp2 = window.scrollY;
                         if (temp2 === temp1)
                           window.scrollTo(window.scrollX, window.scrollY - 1);
                       }, 100);
                     }}
                     dropdownRenderer={({ props, state, methods }) => (
                       <CustomDropdownWithSearch
                         props={props}
                         state={state}
                         methods={methods}
                       />
                     )}
                     contentRenderer={({ props, state, methods }) => (
                       <CustomControl props={props} state={state} methods={methods} />
                     )}
                     onChange={(selected) => {
                       if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                         setSelectedRemoteName(selected);
                         if (selected[0]["value"] === "addNewRemoteName") {
                           setShowRemoteName(true);
                           setDeps("", "8B,856");
                           setCart("", "", "RemoteNameB");
                           setRemoteNameB("");
                         } else {
                           setShowRemoteName(false);
                           setDeps("", "8B,856");
                           setCart("RemoteNameB", selected[0]["value"]);
                           setRemoteNameB(selected[0]["value"]);
                         }
                       }
                     }}
                     options={remoteNames}
                   />
                 </div>
               )}
               {(remoteNames.length === 1 || remoteNames.length === 0) && (
                 <DebounceInput
                   debounceTimeout={1500}
                   onKeyDown={() => setCartLoading(true)}
                   className="Remote_name"
                   type="text"
                   name="Remote_name"
                   value={remoteNameB}
                   placeholder={t("Enter a name for your remote")}
                   onChange={(e) => {
                     setTimeout(() => {
                      setDeps("", "8B,856");
                       setCart("RemoteNameB", capitalizeWordsText(e.target.value));
                       setRemoteNameB(capitalizeWordsText(e.target.value));
                       let tempExtended = extendedTitle;
                       tempExtended["8B"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Remote_name")}
                          </span>
                          <span className="step_title_extended_list_item_text">
                            {capitalizeWordsText(e.target.value)}
                          </span>
                        </li>
                      );
                     }, 300);
                   }}
                 />
               )}
             </div>
             {showRemoteName && (
               <div className="motorized_option_left">
                 <p>&nbsp;</p>
               </div>
             )}
             {showRemoteName && (
               <div className="motorized_option_right">
                 <DebounceInput
                   debounceTimeout={1500}
                   onKeyDown={() => setCartLoading(true)}
                   className="Remote_name"
                   type="text"
                   name="Remote_name"
                   value={remoteNameB}
                   placeholder={t("Enter a name for your remote")}
                   onChange={(e) => {
                     setTimeout(() => {
                      setDeps("", "8B,856");
                       setCart("RemoteNameB", e.target.value);
                       setRemoteNameB(Capitalize(e.target.value));
                     }, 300);
                   }}
                 />
               </div>
             )}
             <div className="motorized_option_left">
               <p>{t("Channel(s)")}</p>
               &nbsp;
               <span onClick={() => modalHandleShow("learnMore4")}>
                 {t("(Learn More)")}
               </span>
             </div>
             <div className="motorized_option_right">
               <div className="select_container multi_select_container">
                 <Select
                   className="select select_motor_channels"
                   placeholder={t("Please Select")}
                   portal={document.body}
                   dropdownPosition="bottom"
                   dropdownHandle={false}
                   dropdownGap={0}
                   multi={true}
                   values={selectedMotorChannelsB}
                   onDropdownOpen={() => {
                    motorChannelsUserOpenRefB.current = true;
                     let temp1 = window.scrollY;
                     window.scrollTo(window.scrollX, window.scrollY + 1);
                     setTimeout(() => {
                       let temp2 = window.scrollY;
                       if (temp2 === temp1)
                         window.scrollTo(window.scrollX, window.scrollY - 1);
                     }, 100);
                   }}
                   dropdownRenderer={({ props, state, methods }) => (
                     <CustomDropdownMulti
                       props={props}
                       state={state}
                       methods={methods}
                     />
                   )}
                   contentRenderer={({ props, state, methods }) => (
                     <CustomControlMulti props={props} state={state} methods={methods} />
                   )}
                   onChange={(selected) => {
                     if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                      if (motorChannelsUserOpenRefB.current) {
                        setDeps("" , "857");
                        motorChannelsUserOpenRefB.current = false;
                      }
                       
                       setCart(
                         "MotorChannelsB",
                         selected.map((obj) => obj.value)
                       );
                       setSelectedMotorChannelsB(selected);
                       let tempExtended = extendedTitle;
                       tempExtended["8B"][4] = (
                         <li key="4" className="step_title_extended_list_item">
                           <span className="step_title_extended_list_item_title">
                             {t("Channel(s)")}
                           </span>
                           <span className="step_title_extended_list_item_text">
                           {selected.map(item => pageLanguage === "fa" ? item.label : item.value)
                        .join(', ')}
                           </span>
                         </li>
                       );
                     }
                   }}
                   options={motorChannels[pageLanguage]}
                 />
               </div>
             </div>
           </div>
         </div>
         <div
           className={
             step8B === "None"
               ? "card_body card_body_radio card_body_have_hardware  card_body_have_hardware_new"
               : "noDisplay"
           }
         >
           <div className="box100">
             <p className="step_selection_title step_selection_title_new">{t("step8B_haveHardware_title")}</p>
           </div>
           <div className="box-step9a">
           <div className="box50 radio_style">
             <div className="same_row_selection_title">{t("Sheer Hardware")}</div>
           </div>
           <div className="box50 radio_style">
             <div className="select_container">
               <Select
                 className="select"
                 placeholder={t("Please Select")}
                 portal={document.body}
                 dropdownPosition="bottom"
                 dropdownHandle={false}
                 dropdownGap={0}
                 values={selectedSheer}
                 onDropdownOpen={() => {
                   let temp1 = window.scrollY;
                   window.scrollTo(window.scrollX, window.scrollY + 1);
                   setTimeout(() => {
                     let temp2 = window.scrollY;
                     if (temp2 === temp1)
                       window.scrollTo(window.scrollX, window.scrollY - 1);
                   }, 100);
                 }}
                 dropdownRenderer={({ props, state, methods }) => (
                   <CustomDropdown props={props} state={state} methods={methods} />
                 )}
                 contentRenderer={({ props, state, methods }) => (
                   <CustomControl props={props} state={state} methods={methods} />
                 )}
                 onChange={(selected) => {
                  setDeps("", "8B,8B1,8B2,86", 1);
                   if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                     setCart("hardwareSheer", selected[0].value);
                     setDeps("", "8B,8B1,8B2,86", 1);
                     setSelectedSheer(selected);
                     let tempExtended = extendedTitle;
                     if (!tempExtended["8B"] || !tempExtended["8B"].length) {
                       tempExtended["8B"] = [t("None")];
                     }
                     tempExtended["8B"][1] = (
                       <li key="1" className="step_title_extended_list_item">
                         <span className="step_title_extended_list_item_title">
                           {t("Sheer Hardware")}
                         </span>
                         <span className="step_title_extended_list_item_text">
                           {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                         </span>
                       </li>
                     );
                     setExtendedTitle(tempExtended);
                   }
                 }}
                 options={sheerDraperyOptions}
               />
             </div>
           </div>
           </div>
         </div>
       </div>
       <NextStep currentStep="8B" eventKey="8C">
         {t("NEXT STEP")}
       </NextStep>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
